// extracted by mini-css-extract-plugin
module.exports = {"quick_cart":"QuickCart_quick_cart__brctj","subtotal":"QuickCart_subtotal__Nqscv"};